// extracted by mini-css-extract-plugin
module.exports = {"select":"Ms8Mh","commentText":"Wz7H4","comment":"WD0rF","new":"o2dEd","commentInfo":"NJHJ7","timeSelector":"oBX1e","regularCommentInfo":"Kp3PB","subLabel":"uf8yh"};